var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33366 13.5352C2.32867 12.8625 1.66699 11.7168 1.66699 10.4167C1.66699 8.46369 3.15992 6.85941 5.06678 6.68281C5.45684 4.31011 7.5172 2.5 10.0003 2.5C12.4835 2.5 14.5438 4.31011 14.9339 6.68281C16.8407 6.85941 18.3337 8.46369 18.3337 10.4167C18.3337 11.7168 17.672 12.8625 16.667 13.5352",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66699 13.3333L10.0003 10M10.0003 10L13.3337 13.3333M10.0003 10L10.0003 17.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadCloud);
export default __webpack_public_path__ + "static/media/IconUploadCloud.b51732cef6c29839a03de67a05905e4e.svg";
export { ForwardRef as ReactComponent };